import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Members
const MemberListPage = lazy(
  () => import("@/features/admin-view/members/pages/member-list-page")
);
const CreateMemberPage = lazy(
  () => import("@/features/admin-view/members/pages/create-member")
);
const MemberDetailsPage = lazy(
  () => import("@/features/admin-view/members/pages/member-details-page")
);
const ImportMentorsPage = lazy(
  () => import("@quest/shared/member/pages/import-mentors")
);
const MentorImportFilesListPage = lazy(
  () => import("@quest/shared/member/pages/mentor-import-files-list")
);
const MentorImportErrorDetailsPage = lazy(
  () => import("@quest/shared/member/pages/mentor-import-error-details")
);

const ManagePermissionsPage = lazy(
  () => import("@quest/shared/member/pages/manage-permissions")
);

export const membersRoutes: RouteObject[] = [
  {
    path: "/admin/members/:slug",
    element: (
      <RequirePermission resource="users">
        <MemberListPage isMentorsView={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/mentors/:slug",
    element: (
      <RequirePermission resource="users">
        <MemberListPage isMentorsView={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/add/:slug",
    element: (
      <RequirePermission resource="users">
        <CreateMemberPage isParent={false} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/:userId/:slug/view",
    element: (
      <RequirePermission resource="users">
        <MemberDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/:userId/:slug/edit",
    element: (
      <RequirePermission resource="users">
        <CreateMemberPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/import-mentors/:slug",
    element: (
      <RequirePermission resource="users">
        <ImportMentorsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/import-mentors-files-list/:slug",
    element: (
      <RequirePermission resource="users">
        <MentorImportFilesListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/import-mentors-error-details/:importId",
    element: (
      <RequirePermission resource="users">
        <MentorImportErrorDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/members/manage-permissions/:slug",
    element: (
      <RequirePermission resource="users" scope="edit">
        <ManagePermissionsPage />
      </RequirePermission>
    ),
  },
];
